import axios from 'axios';

export const saveEventTypeAccess = async (orgId, programId, data) => {
  const response = await axios.put(
    `/organization/${orgId}/program/${programId}/event-type-access`,
    { event_type_access: data }
  );
  return response.data;
};
